import { render, staticRenderFns } from "./ModalIndication.vue?vue&type=template&id=3878f9ba&scoped=true&lang=pug"
import script from "./ModalIndication.vue?vue&type=script&lang=js"
export * from "./ModalIndication.vue?vue&type=script&lang=js"
import style0 from "./ModalIndication.vue?vue&type=style&index=0&id=3878f9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878f9ba",
  null
  
)

export default component.exports